"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorUtils = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ColorUtils = exports.ColorUtils = /*#__PURE__*/function () {
  function ColorUtils() {
    _classCallCheck(this, ColorUtils);
  }
  return _createClass(ColorUtils, null, [{
    key: "hexToRgb",
    value:
    // Parses a hex color string and returns an object with keys r,g,b with the integer values of those color components
    function hexToRgb(hex) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    }

    // chooses white or black font based on the average lightness level of the background color to give a good contrast
  }, {
    key: "fontColorForBackground",
    value: function fontColorForBackground(bgColor) {
      var background = ColorUtils.hexToRgb(bgColor);
      if (!background) return null;
      var ave = 0.2126 * (background.r / 255) + 0.7152 * (background.g / 255) + 0.0722 * (background.b / 255); //get average lightness level
      return ave > 0.5 ? 'black' : 'white';
    }

    // darken the color specfied by hex by the given factor. A factor less than 1.0 darkens, a factor greater than 1.0 lightens
  }, {
    key: "darken",
    value: function darken(hex, factor) {
      var color = ColorUtils.hexToRgb(hex);
      color.r = Math.min(Math.floor(color.r * factor), 255);
      color.g = Math.min(Math.floor(color.g * factor), 255);
      color.b = Math.min(Math.floor(color.b * factor), 255);
      return '#' + color.r.toString(16).padStart(2, '0') + color.g.toString(16).padStart(2, '0') + color.b.toString(16).padStart(2, '0');
    }
  }]);
}();